import { useState } from 'react';
import { useAngularCallback } from 'utils/contexts/angular';
import { useErrorNotification } from './useErrorNotification';
import { ErrorObject } from './types';
import { SEGMENTATION_ERROR_TOAST_KEY } from '../../constants';

export const useAngularSegmentationError = () => {
  const [error, captureError] = useState<ErrorObject | null>(null);
  const resetError = () => captureError(null);

  useAngularCallback(SEGMENTATION_ERROR_TOAST_KEY, captureError);
  useErrorNotification(error, resetError);
};
